import Jibber from '../jibber'
import SVG from 'react-inlinesvg'
import Arrow from './Arrow'
import Button  from './Button'
import TextButton  from './TextButton'
import SVGButton  from './SVGButton'
import AsyncSVGButton  from './AsyncSVGButton'

import Label from './Label'
import SubLabel from './Label/SubLabel'

import Hint from './Hint'
import Spinner from './Spinner'
import Flex from './Flex'
import Div from './Div'
import Dot from './DotPagination/Dot'
import Pagination from './Pagination'
import Tabs from './Tabs'
import {PaymentModal, WelcomeModal, UpgradeModal} from './Modal'
import TryProModal from './Modal/TryProModal'
import RemoveItemModal from './Modal/RemoveItemModal'

import Modal from './Modal'

import {SelectInput, TextInput, AreaInput,
        ToogleInput, FileInput, CheckboxInput,
        SlideInput, NumberInput, RadioInput,
        ToogleSwitch} from './Forms'

import SearchInput from './Forms/SearchInput'

import TicketActivity from './TicketActivity'

import RatingStats from './RatingStats'

import {H3, P1} from './Html'

import MenuSubTitle from './Menu/SubTitle'

// this for the right panel
import TicketPreview from './Ticket/Preview'
// This for the left panel
import LeftPanelConversationPreview from './Conversation/Preview/Conversation'

import {Bubble, ChatBubble} from './TypingIndicator'

import {delayUnmounting} from '/app/src/hoc'

import Tags from './Tags'

import {MarkdownDisplay, MarkdownEditor} from './Markdown'


import DotPagination from './DotPagination'
import DotNavigation from './DotPagination/DotNavigation'

import LoadingScreen from './LoadingScreen'

import HelpDeskItemPreview from './Preview/ClientChat/HelpDeskItem'

import Emoji from './Emoji';

const DelaySpinner = delayUnmounting(Spinner)

export {
    Jibber,
    Flex, Div, Tabs,
    Arrow,
    Button, SVGButton, TextButton, SVG, AsyncSVGButton,
    Label, Hint, SubLabel,
    SelectInput, TextInput, AreaInput, ToogleInput, CheckboxInput,
    SlideInput, NumberInput, RadioInput, FileInput, ToogleSwitch,
    SearchInput, H3,P1, TicketPreview, LeftPanelConversationPreview,
    Spinner, DelaySpinner,
    Pagination, Bubble, ChatBubble,
    Tags,
    MarkdownDisplay, MarkdownEditor,
    Modal,
    DotPagination, DotNavigation, UpgradeModal,
    MenuSubTitle, LoadingScreen, HelpDeskItemPreview,
    TryProModal, PaymentModal, WelcomeModal, RemoveItemModal, Dot, TicketActivity, RatingStats, Emoji
}



// WEBPACK FOOTER //
// ./src/component/index.js